import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';

const Request = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return (
    <section id="Morehealthcare" className="py-20 px-4 md:px-6 bg-white relative overflow-hidden">
      {/* Subtle Background Decoration */}
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-96 h-96 bg-secondColor/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/4 w-96 h-96 bg-primeColor/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="bg-white border border-gray-100 rounded-[2rem] shadow-2xl shadow-gray-200/50 p-8 md:p-12 lg:p-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12 lg:gap-20">
            
            {/* Content Side */}
            <div className={`space-y-8 ${isArabic ? 'text-right order-1 lg:order-2' : 'text-left order-1 lg:order-1'}`}>
              <div className="space-y-4">
                <span className="inline-block no-underline py-1 px-4 rounded-full bg-secondColor/10 text-secondColor font-bold text-sm uppercase tracking-widest">
                  {t('home.other.request.tagline')}
                </span>
                <h3 className="font-extrabold text-primeColor text-3xl md:text-5xl leading-tight">
                  {t('home.other.request.header')}
                </h3>
              </div>

              <p className="text-gray-500 text-lg md:text-xl leading-relaxed max-w-xl">
                {t('home.other.request.description')}
              </p>

              <div className={`flex ${isArabic ? 'justify-start' : 'justify-start'}`}>
                <Link 
                  to="/contact" 
                  className="group  flex items-center gap-3 no-underline bg-primeColor-500 text-white py-4 px-10 rounded-xl shadow-lg hover:bg-secondColor transition-all duration-300 transform hover:-translate-y-1 font-bold text-lg"
                >
                  <span>{t('home.other.request.button')}</span>
                  {isArabic ? (
                    <FaArrowLeft className="group-hover:-translate-x-2 transition-transform" />
                  ) : (
                    <FaArrowRight className="group-hover:translate-x-2 transition-transform" />
                  )}
                </Link>
              </div>
            </div> 

            {/* Image Side with Layered Effect */}
            <div className={`relative  order-2 ${isArabic ? 'lg:order-1' : 'lg:order-2'}`}>
              {/* Decorative Background Box */}
              <div className={`absolute  -bottom-6 -right-6 w-full h-full border-2 border-primeColor-500 rounded-3xl hidden md:block ${isArabic ? '-bottom-6 -left-6' : ''}`}></div>
              
              <div className="relative z-10 w-full overflow-hidden rounded-3xl shadow-2xl group">
                <img 
                  className="w-full h-[300px] md:h-[450px] object-cover transition-transform duration-1000 group-hover:scale-110" 
                  src="https://res.cloudinary.com/dgcfs0gyw/image/upload/v1767476914/AF1QipO4EV9Fc-THt0xM08gYcL2w_tEiB1k6kX6P5TZv_s1360-w1360-h1020-rw_bkzzk6.webp" 
                  alt="Healthcare services" 
                />
                
                {/* Image Overlay */}
                <div className="absolute inset-0 bg-gradient-to-tr from-primeColor/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>

              {/* Small Floating Info Box (Optional Detail) */}
              <div className={`absolute -top-4 -right-4 bg-white p-4 rounded-2xl shadow-xl hidden lg:flex items-center gap-3 animate-bounce-slow ${isArabic ? '-right-auto -left-4' : ''}`}>
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-sm font-bold text-primeColor">Available 24/7</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Request;